import React from 'react'
import PropTypes from 'prop-types'

const Note = ({ value, onChange, containerClassName, inputClassName }) => {
    return (
        <div className={containerClassName}>
            <div className="note-header">
                <h6>Special request</h6>
            </div>
            <textarea
                className={inputClassName}
                placeholder="Please note that special request is on best effort basis. We cannot guarantee that your special request can be met."
                style={{
                    resize: 'none',
                    width: '100%',
                    minHeight: '120px',
                    padding: '10px 14px',
                    fontSize: '14px',
                    fontWeight: 'normal',
                    backgroundColor: '#ffffff',
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    boxSizing: 'border-box',
                    outline: 'none',
                    transition: 'all 0.2s ease',
                }}
                value={value}
                onChange={e => onChange(e.target.value)}
            />
        </div>
    )
}

Note.propTypes = {
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    containerClassName: PropTypes.string,
    inputClassName: PropTypes.string,
}

export default Note
